// -----------------------------------------------------------------------------
// Constants
// -----------------------------------------------------------------------------

export const NAME = 'dfbTooltip'
const CLASS = 'dfb-Tooltip'

export const ClassName = {
  ROOT: CLASS,
  ROOT_INVERTED: `${CLASS}--inverted`,
  LABEL: `${CLASS}-label`,
  SCREENREADER: `${CLASS}-screenreader`
}

export const Selector = {
  ROOT: `.${ClassName.ROOT}`,
  ROOT_DATATOGGLE: `[data-toggle="tooltip"]`,
  LABEL: `.${ClassName.LABEL}`,
  SCREENREADER: `.${ClassName.SCREENREADER}`
}

export const States = {
  VISIBLE: 'is-visible',
  TOOLTIP_VISIBLE: 'is-tooltipVisible'
}

export const Event = {
  CLICK: `click`
}
